import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { theme } from '../../../theme/theme'
import { UserAvatar } from '../../common/Avatar'
import { userQueries } from '../../../api/users'

interface PostCreateButtonProps {
  userId: string
  onClick: () => void
}

export const PostCreateButton = ({
  userId,
  onClick,
}: PostCreateButtonProps): React.ReactNode => {
  const { data: user } = useQuery(userQueries.getUser(userId))

  const { translate } = useAppTranslation()

  return (
    <button
      className="flex h-16 w-full items-center gap-2 rounded-2xl
          border border-neutral-80 bg-white px-6 py-3 text-neutral-40 shadow"
      onClick={onClick}
    >
      <UserAvatar size={40} user={user} />
      <p
        className="flex flex-1 rounded-2xl px-3 py-2 hover:bg-neutral-96"
        style={theme.textVariants.baseBold}
      >
        {translate('feedView.newPost')}
      </p>
    </button>
  )
}
